/* Small progressive enhancements for the existing Kalles components. */
(function () {
  'use strict';
  if (window.iprintsyOptimizationLoaded) return;
  window.iprintsyOptimizationLoaded = true;
  var labels = window.iprintsyOptimizationLabels || {};

  function labelIfMissing(element, label) {
    if (!element || !label || element.hasAttribute('aria-label') ||
        element.hasAttribute('aria-labelledby')) return;
    element.setAttribute('aria-label', label);
  }

  function each(root, selector, callback) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  function enhanceControls(root) {
    each(root, '.t4s-push-menu-btn', function (el) {
      labelIfMissing(el, labels.openMenu);
    });
    each(root, '.t4s-site-nav__search > a', function (el) {
      labelIfMissing(el, labels.search);
    });
    each(root, '.t4s-site-nav__account > a', function (el) {
      labelIfMissing(el, labels.account);
    });
    each(root, '.t4s-site-nav__cart > a', function (el) {
      labelIfMissing(el, labels.cart);
    });
    each(root, '[data-decrease-qty]', function (el) {
      labelIfMissing(el, labels.decreaseQuantity);
    });
    each(root, '[data-increase-qty]', function (el) {
      labelIfMissing(el, labels.increaseQuantity);
    });
    each(root, 'input[data-quantity-value]', function (el) {
      labelIfMissing(el, labels.quantity);
    });
    each(root, '.t4s-search-form__clear-action', function (el) {
      labelIfMissing(el, labels.clearSearch);
    });
    each(root, '.t4s-search-form__connected-submit', function (el) {
      labelIfMissing(el, labels.search);
    });
    each(root, '.t4s-search-form__input', function (el) {
      labelIfMissing(el, labels.search);
    });
    each(root, '.t4s-layout__switch button[data-col]', function (el) {
      var columns = el.getAttribute('data-col');
      var label = columns === 'list_t4s' ? labels.listView :
        (columns === '1' ? labels.gridViewSingle :
          (labels.gridView || '').replace('__count__', columns));
      labelIfMissing(el, label);
    });
    each(root, '#t4s-filter-hidden [data-drawer-close]', function (el) {
      /* The theme currently labels this as Close search, although it is a filter. */
      if (labels.closeFilters) el.setAttribute('aria-label', labels.closeFilters);
    });
  }

  function installSearchRecovery() {
    var template = document.getElementById('ipr-search-recovery-template');
    var target = document.querySelector('.t4s-search-page .t4s-coll-empty');
    if (!template || !target || target.querySelector('.ipr-search-recovery')) return;
    target.appendChild(template.content.cloneNode(true));
  }

  var filterOpener = null;
  var filterDrawer = null;
  var observedDrawer = null;

  function isVisible(element) {
    return element && element.isConnected && element.getClientRects().length > 0;
  }

  function filterTrigger(element) {
    if (!element) return null;
    var trigger = element.closest('.t4s-btn-filter, [data-drawer-options]');
    if (!trigger) return null;
    if (trigger.classList.contains('t4s-btn-filter')) return trigger;
    try {
      var options = JSON.parse(trigger.getAttribute('data-drawer-options'));
      return options.id && options.id.indexOf('#t4s-filter-hidden') !== -1 ? trigger : null;
    } catch (error) {
      return null;
    }
  }

  function returnFilterFocus() {
    if (!filterDrawer || !filterDrawer.contains(document.activeElement)) return;
    var opener = filterOpener;
    if (!isVisible(opener)) {
      opener = Array.from(document.querySelectorAll('.t4s-btn-filter, [data-drawer-options]'))
        .find(function (el) { return filterTrigger(el) && isVisible(el); });
    }
    if (opener) opener.focus({ preventScroll: true });
  }

  function watchFilterDrawer() {
    filterDrawer = document.getElementById('t4s-filter-hidden');
    if (filterDrawer) enhanceControls(filterDrawer);
    if (!filterDrawer || observedDrawer === filterDrawer) return;
    observedDrawer = filterDrawer;
    new MutationObserver(function () {
      if (filterDrawer.getAttribute('aria-hidden') === 'true') returnFilterFocus();
    }).observe(filterDrawer, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  /* Restore focus before Kalles hides the drawer, avoiding a focused link inside
     aria-hidden. This does not intercept filtering, URLs or the theme's close flow. */
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var opener = filterTrigger(event.target);
    if (opener) {
      filterOpener = opener;
      watchFilterDrawer();
      return;
    }
    if (!filterDrawer) return;
    var close = event.target.closest('[data-drawer-close]');
    var filterLink = event.target.closest('[data-filter-links] a:not([data-not-a-filter])');
    var overlay = event.target.closest('.t4s-close-overlay');
    if ((close && filterDrawer.contains(close)) || filterLink || overlay) returnFilterFocus();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') returnFilterFocus();
  }, true);

  function init() {
    enhanceControls(document);
    installSearchRecovery();
    watchFilterDrawer();
    /* Kalles loads quick views and drawers dynamically. Batch added nodes once
       per animation frame. Only refresh the empty state or drawer when a matching
       component is inserted; review updates do not trigger page-wide queries. */
    var addedRoots = new Set();
    var framePending = false;

    function flushAddedNodes() {
      framePending = false;
      var refreshSearch = false;
      var refreshDrawer = false;
      addedRoots.forEach(function (node) {
        if (!node.isConnected) return;
        enhanceControls(node);
        if (node.matches('.t4s-coll-empty') || node.querySelector('.t4s-coll-empty')) refreshSearch = true;
        if (node.matches('#t4s-filter-hidden') || node.querySelector('#t4s-filter-hidden')) refreshDrawer = true;
      });
      addedRoots.clear();
      if (refreshSearch) installSearchRecovery();
      if (refreshDrawer) watchFilterDrawer();
    }

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) addedRoots.add(node);
        });
      });
      if (addedRoots.size && !framePending) {
        framePending = true;
        window.requestAnimationFrame(flushAddedNodes);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
